import { render } from "./test-questions.vue?vue&type=template&id=739285db&scoped=true"
import script from "./test-questions.vue?vue&type=script&lang=js"
export * from "./test-questions.vue?vue&type=script&lang=js"

import "./test-questions.vue?vue&type=style&index=0&id=739285db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739285db"]])

export default __exports__